import Typography from "typography"

const typography = new Typography()

export const rhythm = typography.rhythm
export const scale = typography.scale

export const SizeSM = '768px';
export const SizeMD = '992px';
export const SizeLG = '1200px';